import script from "./CustomActions.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomActions.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./CustomActions.vue?vue&type=style&index=1&id=81d1ea8e&lang=css"

const __exports__ = script;

export default __exports__